import { render, staticRenderFns } from "./Soccer.vue?vue&type=template&id=4606c0e5&scoped=true"
import script from "./Soccer.vue?vue&type=script&lang=js"
export * from "./Soccer.vue?vue&type=script&lang=js"
import style0 from "./Soccer.vue?vue&type=style&index=0&id=4606c0e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4606c0e5",
  null
  
)

export default component.exports